import {mapGetters} from 'vuex';

export const PermissionsPrefixes = {
  DASHBOARD_GENERAL: 'DASHBOARD_GENERAL',
  DASHBOARD_PAYMENTS: 'DASHBOARD_PAYMENTS',
  DASHBOARD_RENEWALS: 'DASHBOARD_RENEWALS',
  DASHBOARD_LEADS: 'DASHBOARD_LEADS',
  DASHBOARD_SERVICING: 'DASHBOARD_SERVICING',
  POLICIES: 'POLICIES',
  CLAIMS: 'CLAIMS',
  RENEWALS: 'RENEWALS',
  RENEWALS_AUTOMATION: 'RENEWALS_AUTOMATION',
  CARRIERS: 'CARRIERS',
  INSURED: 'INSURED',
  PLANS: 'PLANS',
  STORIES: 'STORIES',
  CHAT_BOT: 'CHAT_BOT',
  LEADS: 'LEADS',
  LEADS_STAGES: 'LEADS_STAGES',
  LEADS_AUTOMATION: 'LEADS_AUTOMATION',
  TASKS: 'TASKS',
  TELEMED: 'TELEMED',
  ADD_MEMBERS: 'ADD_MEMBERS',
  INTEGRATIONS: 'INTEGRATIONS',
  SETTINGS: 'SETTINGS',
  MY_PROFILE: 'MY_PROFILE',
  REQUESTS: 'REQUESTS',
  COMPANIES: 'COMPANIES',
};
export const PermissionsTypes = {
  DASHBOARD_LEADS_VIEW: 'DASHBOARD_LEADS_VIEW',
  DASHBOARD_LEADS_CREATE: 'DASHBOARD_LEADS_CREATE',
  DASHBOARD_LEADS_UPDATE: 'DASHBOARD_LEADS_UPDATE',
  DASHBOARD_LEADS_DELETE: 'DASHBOARD_LEADS_DELETE',
  DASHBOARD_LEADS_EXPORT: 'DASHBOARD_LEADS_EXPORT',

  DASHBOARD_GENERAL_VIEW: 'DASHBOARD_GENERAL_VIEW',
  DASHBOARD_GENERAL_CREATE: 'DASHBOARD_GENERAL_CREATE',
  DASHBOARD_GENERAL_UPDATE: 'DASHBOARD_GENERAL_UPDATE',
  DASHBOARD_GENERAL_DELETE: 'DASHBOARD_GENERAL_DELETE',
  DASHBOARD_GENERAL_EXPORT: 'DASHBOARD_GENERAL_EXPORT',

  DASHBOARD_PAYMENTS_VIEW: 'DASHBOARD_PAYMENTS_VIEW',
  DASHBOARD_PAYMENTS_CREATE: 'DASHBOARD_PAYMENTS_CREATE',
  DASHBOARD_PAYMENTS_UPDATE: 'DASHBOARD_PAYMENTS_UPDATE',
  DASHBOARD_PAYMENTS_DELETE: 'DASHBOARD_PAYMENTS_DELETE',
  DASHBOARD_PAYMENTS_EXPORT: 'DASHBOARD_PAYMENTS_EXPORT',

  DASHBOARD_RENEWALS_VIEW: 'DASHBOARD_RENEWALS_VIEW',
  DASHBOARD_RENEWALS_CREATE: 'DASHBOARD_RENEWALS_CREATE',
  DASHBOARD_RENEWALS_UPDATE: 'DASHBOARD_RENEWALS_UPDATE',
  DASHBOARD_RENEWALS_DELETE: 'DASHBOARD_RENEWALS_DELETE',
  DASHBOARD_RENEWALS_EXPORT: 'DASHBOARD_RENEWALS_EXPORT',

  DASHBOARD_SERVICING_VIEW: 'DASHBOARD_SERVICING_VIEW',
  DASHBOARD_SERVICING_CREATE: 'DASHBOARD_SERVICING_CREATE',
  DASHBOARD_SERVICING_UPDATE: 'DASHBOARD_SERVICING_UPDATE',
  DASHBOARD_SERVICING_DELETE: 'DASHBOARD_SERVICING_DELETE',
  DASHBOARD_SERVICING_EXPORT: 'DASHBOARD_SERVICING_EXPORT',

  SALES_GOALS_VIEW: 'SALES_GOALS_VIEW',
  SALES_GOALS_CREATE: 'SALES_GOALS_CREATE',
  SALES_GOALS_DELETE: 'SALES_GOALS_DELETE',

  POLICIES_VIEW: 'POLICIES_VIEW',
  POLICIES_CREATE: 'POLICIES_CREATE',
  POLICIES_UPDATE: 'POLICIES_UPDATE',
  POLICIES_DELETE: 'POLICIES_DELETE',
  POLICIES_EXPORT: 'POLICIES_EXPORT',

  RENEWALS_VIEW: 'RENEWALS_VIEW',
  RENEWALS_CREATE: 'RENEWALS_CREATE',
  RENEWALS_UPDATE: 'RENEWALS_UPDATE',
  RENEWALS_DELETE: 'RENEWALS_DELETE',
  RENEWALS_EXPORT: 'RENEWALS_EXPORT',

  INSURED_VIEW: 'INSURED_VIEW',
  INSURED_CREATE: 'INSURED_CREATE',
  INSURED_UPDATE: 'INSURED_UPDATE',
  INSURED_DELETE: 'INSURED_DELETE',
  INSURED_EXPORT: 'INSURED_EXPORT',

  PLANS_VIEW: 'PLANS_VIEW',
  PLANS_CREATE: 'PLANS_CREATE',
  PLANS_UPDATE: 'PLANS_UPDATE',
  PLANS_DELETE: 'PLANS_DELETE',
  PLANS_EXPORT: 'PLANS_EXPORT',

  STORIES_VIEW: 'STORIES_VIEW',
  STORIES_CREATE: 'STORIES_CREATE',
  STORIES_UPDATE: 'STORIES_UPDATE',
  STORIES_DELETE: 'STORIES_DELETE',
  STORIES_EXPORT: 'STORIES_EXPORT',

  LEADS_VIEW: 'LEADS_VIEW',
  LEADS_CREATE: 'LEADS_CREATE',
  LEADS_UPDATE: 'LEADS_UPDATE',
  LEADS_DELETE: 'LEADS_DELETE',
  LEADS_EXPORT: 'LEADS_EXPORT',

  LEADS_STAGES_VIEW: 'LEADS_STAGES_VIEW',
  LEADS_STAGES_CREATE: 'LEADS_STAGES_CREATE',
  LEADS_STAGES_UPDATE: 'LEADS_STAGES_UPDATE',
  LEADS_STAGES_DELETE: 'LEADS_STAGES_DELETE',
  LEADS_STAGES_EXPORT: 'LEADS_STAGES_EXPORT',

  TASKS_VIEW: 'TASKS_VIEW',
  TASKS_CREATE: 'TASKS_CREATE',
  TASKS_UPDATE: 'TASKS_UPDATE',
  TASKS_DELETE: 'TASKS_DELETE',
  TASKS_EXPORT: 'TASKS_EXPORT',

  TELEMED_VIEW: 'TELEMED_VIEW',
  TELEMED_CREATE: 'TELEMED_CREATE',
  TELEMED_UPDATE: 'TELEMED_UPDATE',
  TELEMED_DELETE: 'TELEMED_DELETE',
  TELEMED_EXPORT: 'TELEMED_EXPORT',

  ADD_MEMBERS_VIEW: 'ADD_MEMBERS_VIEW',
  ADD_MEMBERS_CREATE: 'ADD_MEMBERS_CREATE',
  ADD_MEMBERS_UPDATE: 'ADD_MEMBERS_UPDATE',
  ADD_MEMBERS_DELETE: 'ADD_MEMBERS_DELETE',
  ADD_MEMBERS_EXPORT: 'ADD_MEMBERS_EXPORT',

  INTEGRATIONS_VIEW: 'INTEGRATIONS_VIEW',
  INTEGRATIONS_CREATE: 'INTEGRATIONS_CREATE',
  INTEGRATIONS_UPDATE: 'INTEGRATIONS_UPDATE',
  INTEGRATIONS_DELETE: 'INTEGRATIONS_DELETE',
  INTEGRATIONS_EXPORT: 'INTEGRATIONS_EXPORT',

  MY_PROFILE_VIEW: 'MY_PROFILE_VIEW',
  MY_PROFILE_CREATE: 'MY_PROFILE_CREATE',
  MY_PROFILE_UPDATE: 'MY_PROFILE_UPDATE',
  MY_PROFILE_DELETE: 'MY_PROFILE_DELETE',
  MY_PROFILE_EXPORT: 'MY_PROFILE_EXPORT',

  REQUESTS_VIEW: 'REQUESTS_VIEW',
  REQUESTS_CREATE: 'REQUESTS_CREATE',
  REQUESTS_UPDATE: 'REQUESTS_UPDATE',
  REQUESTS_DELETE: 'REQUESTS_DELETE',
  REQUESTS_EXPORT: 'REQUESTS_EXPORT',

  COMPANIES_VIEW: 'COMPANIES_VIEW',
  COMPANIES_CREATE: 'COMPANIES_CREATE',
  COMPANIES_UPDATE: 'COMPANIES_UPDATE',
  COMPANIES_DELETE: 'COMPANIES_DELETE',
  COMPANIES_EXPORT: 'COMPANIES_EXPORT',

  CHAT_BOT_VIEW: 'CHAT_BOT_VIEW',
  CHAT_BOT_CREATE: 'CHAT_BOT_CREATE',
  CHAT_BOT_UPDATE: 'CHAT_BOT_UPDATE',
  CHAT_BOT_DELETE: 'CHAT_BOT_DELETE',
  CHAT_BOT_EXPORT: 'CHAT_BOT_EXPORT',

  RENEWALS_AUTOMATION_VIEW: 'RENEWALS_AUTOMATION_VIEW',
  RENEWALS_AUTOMATION_CREATE: 'RENEWALS_AUTOMATION_CREATE',
  RENEWALS_AUTOMATION_UPDATE: 'RENEWALS_AUTOMATION_UPDATE',
  RENEWALS_AUTOMATION_DELETE: 'RENEWALS_AUTOMATION_DELETE',
  RENEWALS_AUTOMATION_EXPORT: 'RENEWALS_AUTOMATION_EXPORT',

  CARRIERS_VIEW: 'CARRIERS_VIEW',
  CARRIERS_CREATE: 'CARRIERS_CREATE',
  CARRIERS_UPDATE: 'CARRIERS_UPDATE',
  CARRIERS_DELETE: 'CARRIERS_DELETE',
  CARRIERS_EXPORT: 'CARRIERS_EXPORT',

  LEADS_AUTOMATION_VIEW: 'LEADS_AUTOMATION_VIEW',
  LEADS_AUTOMATION_CREATE: 'LEADS_AUTOMATION_CREATE',
  LEADS_AUTOMATION_UPDATE: 'LEADS_AUTOMATION_UPDATE',
  LEADS_AUTOMATION_DELETE: 'LEADS_AUTOMATION_DELETE',
  LEADS_AUTOMATION_EXPORT: 'LEADS_AUTOMATION_EXPORT',

  CLAIMS_VIEW: 'CLAIMS_VIEW',
  CLAIMS_CREATE: 'CLAIMS_CREATE',
  CLAIMS_UPDATE: 'CLAIMS_UPDATE',
  CLAIMS_DELETE: 'CLAIMS_DELETE',
  CLAIMS_EXPORT: 'CLAIMS_EXPORT',
};
export const ConnectedPermissionsWithRequests = [
  PermissionsTypes.POLICIES_VIEW,
  PermissionsTypes.INSURED_VIEW,
  PermissionsTypes.COMPANIES_VIEW,
  PermissionsTypes.RENEWALS_VIEW,
  PermissionsTypes.PLANS_VIEW,
];
export const checkUserPermissions = (types, permissions) => types?.every((type) => permissions?.some((permission) => permission.permission === type && permission.value === 'ALLOW'));
export const checkOptionalUserPermissions = (types, permissions) => types?.some((type) => permissions?.some((permission) => permission.permission === type && permission.value === 'ALLOW'));

export const UserPermissions = {
  computed: {
    ...mapGetters(['permissions', 'isUserSuperAdmin']),
    PermissionsTypes() {
      return PermissionsTypes;
    },
  },
  methods: {
    checkUserPermissions(permissionsForCheck) {
      return this.isUserSuperAdmin || checkUserPermissions(permissionsForCheck, this.permissions);
    },
    onlyOwnAllowed(permissionsForCheck) {
      return this.isUserSuperAdmin || permissionsForCheck?.every((type) => this.permissions?.some((permission) => (
        permission.permission === type
        && permission.onlyOwnEntities
      )));
    },
    checkOptionalUserPermissions(permissionsForCheck) {
      return (
        this.isUserSuperAdmin || checkOptionalUserPermissions(permissionsForCheck, this.permissions)
      );
    },
  },
};
